// extracted by mini-css-extract-plugin
export default {"section":"parser_section__j7O8y","title":"parser_title__PgQK-","wrapper":"parser_wrapper__zUOlA"};